import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'descripcion',
    label: i18n('entities.tipoActivo.fields.descripcion'),
    schema: schemas.string(
      i18n('entities.tipoActivo.fields.descripcion'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoActivo.fields.habilitado'),
    schema: schemas.boolean(
      i18n('entities.tipoActivo.fields.habilitado'),
      {},
    ),
  },
  {
    name: 'activosVinculados',
    label: i18n('entities.tipoActivo.fields.activosVinculados'),
    schema: schemas.relationToMany(
      i18n('entities.tipoActivo.fields.activosVinculados'),
      {},
    ),
  },
];